module.exports = __webpack_public_path__ + "static/media/cross.35af94f0.svg";